__turbopack_context__.v({
  "avatar": "ListLoader-module-scss-module__jfpNIG__avatar",
  "body": "ListLoader-module-scss-module__jfpNIG__body",
  "desktop": "ListLoader-module-scss-module__jfpNIG__desktop",
  "header": "ListLoader-module-scss-module__jfpNIG__header",
  "mobile": "ListLoader-module-scss-module__jfpNIG__mobile",
  "root": "ListLoader-module-scss-module__jfpNIG__root",
  "tag": "ListLoader-module-scss-module__jfpNIG__tag",
  "tags": "ListLoader-module-scss-module__jfpNIG__tags",
});
